(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverToplists = Marionette.View.extend({
    activeTab: 'lastPicked',
    template: function(data) {
      return svs.grassroots.templates.receiver_toplists(data);
    },
    events: {
      'click .js-last-picked': 'lastPicked',
      'click .js-most-popular': 'sortList',
      'click .js-most-popular-points': 'sortList'
    },

    lastPicked: function() {
      svs.grassroots.collections.grassroots.trigger('change');
    },

    templateContext: function() {
      return {
        activeTab: this.getOption('activeTab')
      };
    },

    sortList: function(event) {
      var listType = $(event.currentTarget).data('listtype');
      svs.grassroots.collections.grassroots.orderTopList(listType);
    }
  });
})(Backbone, _, svs);


 })(window);